/**
 * Document titles that are also rendered into the initial HTML response by
 * `web/serverMetadata.js`. Googlebot executes JavaScript, so the title set here
 * after hydration is the one that gets indexed — if these drift apart, the
 * server-rendered title is wasted. `web/serverMetadata.test.js` asserts they
 * produce identical strings.
 */
export const restaurantDocumentTitle = (restaurantName: string) =>
  `Book Your Reservation at ${restaurantName} on Peak`;

export const siteDocumentTitle = 'Peak | Book Restaurant Reservations';
